/**
 * Labstep
 *
 * @module prosemirror/schema
 * @desc ProseMirror schema
 */

import { spec as marksSpec } from 'labstep-web/prosemirror/marks';
import { spec as nodesSpec } from 'labstep-web/prosemirror/nodes';
import { Schema } from 'prosemirror-model';
import type { EditorState } from 'prosemirror-state';

const schema = new Schema({
  nodes: nodesSpec,
  marks: marksSpec,
});

export type LabstepEditorState = EditorState;

export default schema;
